export const ACCOUNTING = {
  COMMON: {
    SELECT: {
      // Seleccionar tercero
      // Select third party
      TERCERO: 'ACCOUNTING.CAUSACION.SELECT.TERCERO',
    },
    BALANCE_SUMMARY: {
      LABEL: {
        DIFFERENCE_DEBIT_CREDIT: 'ACCOUNTING.COMMON.BALANCE_SUMMARY.LABEL.DIFFERENCE_DEBIT_CREDIT',
        TOTAL_CREDIT: 'ACCOUNTING.COMMON.BALANCE_SUMMARY.LABEL.TOTAL_CREDIT',
        TOTAL_DEBIT: 'ACCOUNTING.COMMON.BALANCE_SUMMARY.LABEL.TOTAL_DEBIT',
        BALANCED: 'ACCOUNTING.COMMON.BALANCE_SUMMARY.LABEL.BALANCED',
        NOT_BALANCED: 'ACCOUNTING.COMMON.BALANCE_SUMMARY.LABEL.NOT_BALANCED',
      },
    },
  },
  ACCOUNTING_CONCEPTS: {
    COUNTER: {
      // concepto
      LABEL_SINGULAR: 'ACCOUNTING.ACCOUNTING_CONCEPTS.COUNTER.LABEL_SINGULAR',

      // conceptos
      LABEL_PLURAL: 'ACCOUNTING.ACCOUNTING_CONCEPTS.COUNTER.LABEL_PLURAL',
    },

    PLACEHOLDER: {
      // Buscar por código o nombre
      // Search by code or name
      SEARCH: 'ACCOUNTING.ACCOUNTING_CONCEPTS.PLACEHOLDER.SEARCH',
      //Seleccione un tipo de asiento
      JOURNAL_ENTRY_TYPE: 'ACCOUNTING.ACCOUNTING_CONCEPTS.PLACEHOLDER.JOURNAL_ENTRY_TYPE',
    },

    EMPTY: {
      //No se encontraron conceptos contables
      MESSAGE: 'ACCOUNTING.CAUSACION.EMPTY.MESSAGE',

      // Intenta con otro término de búsqueda o limpia los filtros.
      DESCRIPTION: 'ACCOUNTING.CAUSACION.EMPTY.DESCRIPTION',
    },

    LABEL: {
      //tipos de asiento
      JOURNAL_ENTRY_TYPE: 'ACCOUNTING.CAUSACION.LABEL.JOURNAL_ENTRY_TYPE',

      // CODIGOr
      CODE: 'ACCOUNTING.CAUSACION.LABEL.CODE', // TO DO: SI ESTA EN BD CAMBIA LA KEY

      // Nombre
      NAME: 'ACCOUNTING.CAUSACION.LABEL.NAME', // TO DO: SI ESTA EN BD CAMBIA LA KEY

      // ESTADO
      STATUS: 'ACCOUNTING.CAUSACION.LABEL.STATUS', // TO DO: SI ESTA EN BD CAMBIA LA KEY
    },

    TOOLTIP: {
      //tipos de asiento
      JOURNAL_ENTRY_TYPE: 'ACCOUNTING.CAUSACION.TOOLTIP.JOURNAL_ENTRY_TYPE',

      // Código del concepto contable
      CODE: 'ACCOUNTING.CAUSACION.TOOLTIP.CODE',

      // Nombre del concepto contable
      NAME: 'ACCOUNTING.CAUSACION.TOOLTIP.NAME',
      STATUS: 'ACCOUNTING.CAUSACION.TOOLTIP.STATUS',
    },

    OPTION: {
      // Sí
      // Yes
      SI: 'ACCOUNTING.CAUSACION.OPTION.SI', // TO DO: SI ESTA EN BD CAMBIA LA KEY

      // No
      // No
      NO: 'ACCOUNTING.CAUSACION.OPTION.NO', // TO DO: SI ESTA EN BD CAMBIA LA KEY
    },

    COLUMNS_NAMES: {
      // CODIGOr
      CODE: 'ACCOUNTING.CAUSACION.LABEL.CODE', // TO DO: SI ESTA EN BD CAMBIA LA KEY

      // Nombre
      NAME: 'ACCOUNTING.CAUSACION.LABEL.NAME', // TO DO: SI ESTA EN BD CAMBIA LA KEY

      // ESTADO
      STATUS: 'ACCOUNTING.CAUSACION.LABEL.STATUS', // TO DO: SI ESTA EN BD CAMBIA LA KEY
    },
    MESSAGES: {
      WARNING: {
        SELECCIONAR_TERCERO: 'ACCOUNTING.CAUSACION.WARNING.SELECCIONAR_TERCERO',
      },
      SUCCESS: {
        // Tercero encontrado
        // Third party found
        THIRD_PARTY_FOUND: 'ACCOUNTING.CAUSACION.MESSAGE.THIRD_PARTY_FOUND',
        THIRD_PARTY_NAME: 'ACCOUNTING.CAUSACION.COLUMNS_NAMES.THIRD_PARTY',
        THIRD_PARTY_NO_IDENTIFICATION:
          'ACCOUNTING.CAUSACION.COLUMNS_NAMES.THIRD_PARTY_NO_IDENTIFICATION',
        // Tercero seleccionado
        // Third party selected
        TERCERO_SELECCIONADO: 'ACCOUNTING.CAUSACION.MESSAGES.TERCERO_SELECCIONADO',
        // Asiento importado exitosamente. Total Débito: {0}, Total Crédito: {1}
        // Entry imported successfully. Total Debit: {0}, Total Credit: {1}
        ASIENTO_IMPORTADO: 'ACCOUNTING.CAUSACION.MESSAGES.SUCCESS.ASIENTO_IMPORTADO',

        // Deducción aplicada exitosamente. {0}% - {1}
        // Deduction applied successfully. {0}% - {1}
        DEDUCCION_APLICADA: 'ACCOUNTING.CAUSACION.MESSAGES.SUCCESS.DEDUCCION_APLICADA',

        // Plantilla exportada exitosamente en formato {0}
        // Template exported successfully in {0} format
        PLANTILLA_EXPORTADA: 'ACCOUNTING.CAUSACION.MESSAGES.SUCCESS.PLANTILLA_EXPORTADA',

        // Deducción actualizada exitosamente
        // Deduction updated successfully
        DEDUCCION_ACTUALIZADA: 'ACCOUNTING.CAUSACION.MESSAGES.SUCCESS.DEDUCCION_ACTUALIZADA',

        // Diferido aplicado correctamente. {0}: {1}
        // Deferred applied successfully. {0}: {1}
        DIFERIDO_APLICADO: 'ACCOUNTING.CAUSACION.MESSAGES.SUCCESS.DIFERIDO_APLICADO',
      },
      ERRORS: {
        // Errores de fecha expedición
        FECHA_EXPEDICION_REQUIRED: 'ACCOUNTING.CAUSACION.ERROR.FECHA_EXPEDICION_REQUIRED',
        FECHA_FUTURA: 'ACCOUNTING.CAUSACION.ERROR.FECHA_FUTURA',

        // Errores de fecha vencimiento
        FECHA_VENCIMIENTO_REQUIRED: 'ACCOUNTING.CAUSACION.ERROR.FECHA_VENCIMIENTO_REQUIRED',
        FECHA_VENC_MENOR_EXPEDICION: 'ACCOUNTING.CAUSACION.ERROR.FECHA_VENC_MENOR_EXPEDICION',

        // Errores de fecha radicación
        FECHA_RADICACION_REQUIRED: 'ACCOUNTING.CAUSACION.ERROR.FECHA_RADICACION_REQUIRED',
        FECHA_RAD_FUTURA: 'ACCOUNTING.CAUSACION.ERROR.FECHA_RAD_FUTURA',
        FECHA_RAD_MENOR_EXPEDICION: 'ACCOUNTING.CAUSACION.ERROR.FECHA_RAD_MENOR_EXPEDICION',

        // Tercero no encontrado El No. Identificación no existe o no está activo. Abriendo selector
        // Third party not found
        THIRD_PARTY_NOT_FOUND: 'ACCOUNTING.CAUSACION.MESSAGE.THIRD_PARTY_NOT_FOUND',
        // Tercero no existe o está inactivo
        // Third party does not exist or is inactive
        TERCERO_NO_EXISTE_O_INACTIVO: 'ACCOUNTING.CAUSACION.MESSAGES.TERCERO_NO_EXISTE_O_INACTIVO',

        // Error al validar tercero
        // Error validating third party
        ERROR_VALIDAR_TERCERO: 'ACCOUNTING.CAUSACION.MESSAGES.ERROR_VALIDAR_TERCERO',
        // Error al buscar terceros
        // Error searching third parties
        ERROR_BUSCAR_TERCEROS: 'ACCOUNTING.CAUSACION.MESSAGES.ERROR_BUSCAR_TERCEROS',

        // Error al cargar información adicional del asiento
        // Error loading additional entry information
        ERROR_CARGAR_ASIENTO: 'ACCOUNTING.CAUSACION.MESSAGES.ERRORS.ERROR_CARGAR_ASIENTO',

        // Error al obtener cuentas contables
        // Error retrieving chart of accounts
        ERROR_OBTENER_CUENTAS: 'ACCOUNTING.CAUSACION.MESSAGES.ERRORS.ERROR_OBTENER_CUENTAS',

        // Error al obtener terceros
        // Error retrieving third parties
        ERROR_OBTENER_TERCEROS: 'ACCOUNTING.CAUSACION.MESSAGES.ERRORS.ERROR_OBTENER_TERCEROS',

        // Error al exportar la plantilla
        // Error exporting template
        ERROR_EXPORTAR_PLANTILLA: 'ACCOUNTING.CAUSACION.MESSAGES.ERRORS.ERROR_EXPORTAR_PLANTILLA',

        // No se encontró la línea de asiento para actualizar
        // Entry line not found for update
        LINEA_ASIENTO_NO_ENCONTRADA:
          'ACCOUNTING.CAUSACION.MESSAGES.ERRORS.LINEA_ASIENTO_NO_ENCONTRADA',
      },
      WARNINGS: {
        // Cuentas contables no encontradas: {0}
        // Chart of accounts not found: {0}
        CUENTAS_NO_ENCONTRADAS: 'ACCOUNTING.CAUSACION.MESSAGES.WARNINGS.CUENTAS_NO_ENCONTRADAS',

        // No hay datos para exportar
        // No data to export
        NO_HAY_DATOS_EXPORTAR: 'ACCOUNTING.CAUSACION.MESSAGES.WARNINGS.NO_HAY_DATOS_EXPORTAR',

        // No hay deducción para editar
        // No deduction available to edit
        NO_HAY_DEDUCCION: 'ACCOUNTING.CAUSACION.MESSAGES.WARNINGS.NO_HAY_DEDUCCION',

        //Solo se pueden editar documentos en estado RECHAZADO
        //Solo se pueden eliminar documentos en estado RECHAZADO
        EDITAR_SOLO_RECHAZADO: 'ACCOUNTING.CAUSACION.ERROR.EDITAR_SOLO_RECHAZADO',
        ELIMINAR_SOLO_RECHAZADO: 'ACCOUNTING.CAUSACION.ERROR.ELIMINAR_SOLO_RECHAZADO',
      },

      HINTS: {
        // Debe ingresar al menos {0} caracteres
        // Enter at least {0} characters
        MINIMO_CARACTERES: 'ACCOUNTING.CAUSACION.MESSAGES.HINTS.MINIMO_CARACTERES',
      },
    },
  },
  CAUSACION: {
    MODAL: {
      SELECT_ARTICLE: 'ACCOUNTING.CAUSACION.MODAL.SELECT_ARTICLE',
    },
    COUNTER: {
      // Documento
      // Document
      LABEL_SINGULAR: 'ACCOUNTING.CAUSACION.COUNTER.LABEL_SINGULAR',

      // Documentos
      // Documents
      LABEL_PLURAL: 'ACCOUNTING.CAUSACION.COUNTER.LABEL_PLURAL',
    },

    PLACEHOLDER: {
      // Buscar por No. documento, identificación, tercero o estado
      // Search by document number, identification, third party or status
      SEARCH: 'ACCOUNTING.CAUSACION.PLACEHOLDER.SEARCH.message',

      // Buscar por consecutivo o tercero
      // Search by consecutive number or third party
      SEARCH_ORDEN_PAGO: 'ACCOUNTING.CAUSACION.PLACEHOLDER.SEARCH.ORDEN_PAGO',

      // dd/MM/yyyy
      // dd/MM/yyyy
      DATE: 'ACCOUNTING.CAUSACION.PLACEHOLDER.DATE',

      // Seleccione una fecha de expedición
      // Select an issue date
      FECHA_EXPEDICION: 'ACCOUNTING.CAUSACION.PLACEHOLDER.FECHA_EXPEDICION',

      // Seleccione una fecha de vencimiento
      // Select a due date
      FECHA_VENCIMIENTO: 'ACCOUNTING.CAUSACION.PLACEHOLDER.FECHA_VENCIMIENTO',

      // Seleccione una fecha de radicación
      // Select a filing date
      FECHA_RADICACION: 'ACCOUNTING.CAUSACION.PLACEHOLDER.FECHA_RADICACION',
      //Selecione genera OP
      //  Select generates payment order
      GENERA_OP: 'ACCOUNTING.CAUSACION.PLACEHOLDER.GENERA_OP',
      // Descripción
      // Description
      DESCRIPCION: 'ACCOUNTING.CAUSACION.PLACEHOLDER.DESCRIPCION',
    },

    EMPTY: {
      // No se encontraron documentos de causación
      // No accounting documents found
      MESSAGE: 'ACCOUNTING.CAUSACION.EMPTY.MESSAGE',

      // Intenta con otro rango de fechas o término de búsqueda.
      // Try another date range or search term.
      DESCRIPTION: 'ACCOUNTING.CAUSACION.EMPTY.DESCRIPTION',
    },

    TAB: {
      // Factura
      // Invoice
      FACTURA: 'ACCOUNTING.CAUSACION.TAB.FACTURA',

      // Causación Contable
      // Accounting Entry
      CAUSACION_CONTABLE: 'ACCOUNTING.CAUSACION.TAB.CAUSACION_CONTABLE',

      // Saldos de Cuenta
      // Account Balances
      SALDOS_CUENTA: 'ACCOUNTING.CAUSACION.TAB.SALDOS_CUENTA',

      // Orden de Pago
      // Payment Order
      ORDEN_PAGO: 'ACCOUNTING.CAUSACION.TAB.ORDEN_PAGO',
    },

    LABEL: {
      //totales
      TOTALES: 'ACCOUNTING.CAUSACION.LABEL.TOTALES',

      // No. identificación tercero
      // Third-party identification number
      NO_IDENTIFICACION: 'ACCOUNTING.CAUSACION.LABEL.NO_IDENTIFICACION',

      // Nombre Razón Social
      // Business name
      RAZON_SOCIAL: 'ACCOUNTING.CAUSACION.LABEL.RAZON_SOCIAL',

      // No. Documento
      // Document number
      NO_DOCUMENTO: 'ACCOUNTING.CAUSACION.LABEL.NO_DOCUMENTO',

      // Fecha Expedición
      // Issue date
      FECHA_EXPEDICION: 'ACCOUNTING.CAUSACION.LABEL.FECHA_EXPEDICION',
      // Fecha Inicial
      // Issue date
      FECHA_INICIAL: 'ACCOUNTING.CAUSACION.LABEL.FECHA_INICIAL',
      // Fecha Expedición
      // Issue date
      FECHA_FINAL: 'ACCOUNTING.CAUSACION.LABEL.FECHA_FINAL',

      // Fecha Vencimiento
      // Due date
      FECHA_VENCIMIENTO: 'ACCOUNTING.CAUSACION.LABEL.FECHA_VENCIMIENTO',

      // Fecha Radicación
      // Filing date
      FECHA_RADICACION: 'ACCOUNTING.CAUSACION.LABEL.FECHA_RADICACION',

      // Genera OP
      // Generates payment order
      GENERA_OP: 'ACCOUNTING.CAUSACION.LABEL.GENERA_OP',

      // Total Antes Imp.
      // Total before tax
      TOTAL_ANTES_IMPUESTO: 'ACCOUNTING.CAUSACION.LABEL.TOTAL_ANTES_IMPUESTO',

      // Total Impuesto
      // Tax total
      TOTAL_IMPUESTO: 'ACCOUNTING.CAUSACION.LABEL.TOTAL_IMPUESTO',

      // Total Factura
      // Invoice total
      TOTAL_FACTURA: 'ACCOUNTING.CAUSACION.LABEL.TOTAL_FACTURA',

      // Descripción
      // Description
      DESCRIPCION: 'ACCOUNTING.CAUSACION.LABEL.DESCRIPCION',

      // Total Débito:
      // Total debit
      TOTAL_DEBITO: 'ACCOUNTING.CAUSACION.LABEL.TOTAL_DEBITO',

      // Total Crédito:
      // Total credit
      TOTAL_CREDITO: 'ACCOUNTING.CAUSACION.LABEL.TOTAL_CREDITO',

      // Diferencia (Débito - Crédito):
      // Difference (Debit - Credit)
      DIFERENCIA: 'ACCOUNTING.CAUSACION.LABEL.DIFERENCIA',
    },

    TITLE: {
      // Artículos
      // Items
      ARTICULOS: 'ACCOUNTING.CAUSACION.TITLE.ARTICULOS',

      // Detalle Asiento Contable
      // Accounting entry detail
      DETALLE_ASIENTO: 'ACCOUNTING.CAUSACION.TITLE.DETALLE_ASIENTO',

      // Causación de Cuentas
      // Accounting Entries
      LIST_PAGE: 'ACCOUNTING.CAUSACION.TITLE.LIST_PAGE',

      // Nueva Causación
      // New Accounting Entry
      CREATE_PAGE: 'ACCOUNTING.CAUSACION.TITLE.CREATE_PAGE',

      // Editar Causación
      // Edit Accounting Entry
      EDIT_PAGE: 'ACCOUNTING.CAUSACION.TITLE.EDIT_PAGE',

      // Consultar Causación
      // View Accounting Entry
      VIEW_PAGE: 'ACCOUNTING.CAUSACION.TITLE.VIEW_PAGE',
    },
    SUBTITLE: {
      // Gestión de documentos de causación
      // Accounting documents management
      LIST: 'ACCOUNTING.CAUSACION.SUBTITLE.LIST',

      // Complete los datos del nuevo documento
      // Complete the information for the new document
      CREATE: 'ACCOUNTING.CAUSACION.SUBTITLE.CREATE',

      // Modifique los datos del documento
      // Modify the document information
      EDIT: 'ACCOUNTING.CAUSACION.SUBTITLE.EDIT',

      // Detalle del documento de causación
      // Accounting document details
      VIEW: 'ACCOUNTING.CAUSACION.SUBTITLE.VIEW',
    },

    TOOLTIP: {
      // Buscar tercero
      // Search third party
      // Buscar Articulo
      // Search Aticule
      BUSCAR_TERCERO: 'ACCOUNTING.CAUSACION.TOOLTIP.BUSCAR_TERCERO',
      SEARCH_ARTICLE: 'ACCOUNTING.CAUSACION.TOOLTIP.SEARCH_ARTICLE',
    },

    OPTION: {
      // Sí
      // Yes
      SI: 'ACCOUNTING.CAUSACION.OPTION.SI',

      // No
      // No
      NO: 'ACCOUNTING.CAUSACION.OPTION.NO',
    },

    SECTION: {
      ARTICULOS: 'ACCOUNTING.CAUSACION.SECTION.ARTICULOS',
      DETALLE_ASIENTO: 'ACCOUNTING.CAUSACION.SECTION.DETALLE_ASIENTO',
    },

    BUTTON: {
      // Formato Contable
      // Accounting format
      FORMATO_CONTABLE: 'ACCOUNTING.CAUSACION.BUTTON.FORMATO_CONTABLE',

      // Exportar Asiento
      // Export entry
      EXPORTAR_ASIENTO: 'ACCOUNTING.CAUSACION.BUTTON.EXPORTAR_ASIENTO',

      // Importar Asiento
      // Import entry
      IMPORTAR_ASIENTO: 'ACCOUNTING.CAUSACION.BUTTON.IMPORTAR_ASIENTO',
      //Agregar Artículo}//Add article
      AGREGAR_ARTICULO: 'ACCOUNTING.CAUSACION.BUTTON.AGREGAR_ARTICULO',
    },

    COLUMNS_NAMES: {
      // Código Artículo
      // Article code
      CODIGO_ARTICULO: 'ACCOUNTING.CAUSACION.COLUMNS_NAMES.CODIGO_ARTICULO',

      // Nombre
      // Name
      NOMBRE: 'ACCOUNTING.CAUSACION.COLUMNS_NAMES.NOMBRE',

      // Cantidad
      // Quantity
      CANTIDAD: 'ACCOUNTING.CAUSACION.COLUMNS_NAMES.CANTIDAD',

      // Valor Unitario
      // Unit value
      VALOR_UNITARIO: 'ACCOUNTING.CAUSACION.COLUMNS_NAMES.VALOR_UNITARIO',

      // Valor Total
      // Total value
      VALOR_TOTAL: 'ACCOUNTING.CAUSACION.COLUMNS_NAMES.VALOR_TOTAL',

      // Porcentaje Impuesto
      // Tax percentage
      PORCENTAJE_IMPUESTO: 'ACCOUNTING.CAUSACION.COLUMNS_NAMES.PORCENTAJE_IMPUESTO',

      // Valor Antes Impuesto
      // Value before tax
      VALOR_ANTES_IMPUESTO: 'ACCOUNTING.CAUSACION.COLUMNS_NAMES.VALOR_ANTES_IMPUESTO',

      // Valor Impuesto
      // Tax value
      VALOR_IMPUESTO: 'ACCOUNTING.CAUSACION.COLUMNS_NAMES.VALOR_IMPUESTO',

      // Totales
      // Totals
      TOTALES: 'ACCOUNTING.CAUSACION.COLUMNS_NAMES.TOTALES',
    },
    MESSAGES: {
      WARNING: {
        SELECCIONAR_TERCERO: 'ACCOUNTING.CAUSACION.WARNING.SELECCIONAR_TERCERO',
      },
      SUCCESS: {
        // Tercero encontrado
        // Third party found
        THIRD_PARTY_FOUND: 'ACCOUNTING.CAUSACION.MESSAGE.THIRD_PARTY_FOUND',
        THIRD_PARTY_NAME: 'ACCOUNTING.CAUSACION.COLUMNS_NAMES.THIRD_PARTY',
        THIRD_PARTY_NO_IDENTIFICATION:
          'ACCOUNTING.CAUSACION.COLUMNS_NAMES.THIRD_PARTY_NO_IDENTIFICATION',
        // Tercero seleccionado
        // Third party selected
        TERCERO_SELECCIONADO: 'ACCOUNTING.CAUSACION.MESSAGES.TERCERO_SELECCIONADO',
        // Asiento importado exitosamente. Total Débito: {0}, Total Crédito: {1}
        // Entry imported successfully. Total Debit: {0}, Total Credit: {1}
        ASIENTO_IMPORTADO: 'ACCOUNTING.CAUSACION.MESSAGES.SUCCESS.ASIENTO_IMPORTADO',

        // Deducción aplicada exitosamente. {0}% - {1}
        // Deduction applied successfully. {0}% - {1}
        DEDUCCION_APLICADA: 'ACCOUNTING.CAUSACION.MESSAGES.SUCCESS.DEDUCCION_APLICADA',

        // Plantilla exportada exitosamente en formato {0}
        // Template exported successfully in {0} format
        PLANTILLA_EXPORTADA: 'ACCOUNTING.CAUSACION.MESSAGES.SUCCESS.PLANTILLA_EXPORTADA',

        // Deducción actualizada exitosamente
        // Deduction updated successfully
        DEDUCCION_ACTUALIZADA: 'ACCOUNTING.CAUSACION.MESSAGES.SUCCESS.DEDUCCION_ACTUALIZADA',

        // Diferido aplicado correctamente. {0}: {1}
        // Deferred applied successfully. {0}: {1}
        DIFERIDO_APLICADO: 'ACCOUNTING.CAUSACION.MESSAGES.SUCCESS.DIFERIDO_APLICADO',
      },
      ERRORS: {
        // Errores de fecha expedición
        FECHA_EXPEDICION_REQUIRED: 'ACCOUNTING.CAUSACION.ERROR.FECHA_EXPEDICION_REQUIRED',
        FECHA_FUTURA: 'ACCOUNTING.CAUSACION.ERROR.FECHA_FUTURA',

        // Errores de fecha vencimiento
        FECHA_VENCIMIENTO_REQUIRED: 'ACCOUNTING.CAUSACION.ERROR.FECHA_VENCIMIENTO_REQUIRED',
        FECHA_VENC_MENOR_EXPEDICION: 'ACCOUNTING.CAUSACION.ERROR.FECHA_VENC_MENOR_EXPEDICION',

        // Errores de fecha radicación
        FECHA_RADICACION_REQUIRED: 'ACCOUNTING.CAUSACION.ERROR.FECHA_RADICACION_REQUIRED',
        FECHA_RAD_FUTURA: 'ACCOUNTING.CAUSACION.ERROR.FECHA_RAD_FUTURA',
        FECHA_RAD_MENOR_EXPEDICION: 'ACCOUNTING.CAUSACION.ERROR.FECHA_RAD_MENOR_EXPEDICION',

        // Tercero no encontrado El No. Identificación no existe o no está activo. Abriendo selector
        // Third party not found
        THIRD_PARTY_NOT_FOUND: 'ACCOUNTING.CAUSACION.MESSAGE.THIRD_PARTY_NOT_FOUND',
        // Tercero no existe o está inactivo
        // Third party does not exist or is inactive
        TERCERO_NO_EXISTE_O_INACTIVO: 'ACCOUNTING.CAUSACION.MESSAGES.TERCERO_NO_EXISTE_O_INACTIVO',

        // Error al validar tercero
        // Error validating third party
        ERROR_VALIDAR_TERCERO: 'ACCOUNTING.CAUSACION.MESSAGES.ERROR_VALIDAR_TERCERO',
        // Error al buscar terceros
        // Error searching third parties
        ERROR_BUSCAR_TERCEROS: 'ACCOUNTING.CAUSACION.MESSAGES.ERROR_BUSCAR_TERCEROS',

        // Error al cargar información adicional del asiento
        // Error loading additional entry information
        ERROR_CARGAR_ASIENTO: 'ACCOUNTING.CAUSACION.MESSAGES.ERRORS.ERROR_CARGAR_ASIENTO',

        // Error al obtener cuentas contables
        // Error retrieving chart of accounts
        ERROR_OBTENER_CUENTAS: 'ACCOUNTING.CAUSACION.MESSAGES.ERRORS.ERROR_OBTENER_CUENTAS',

        // Error al obtener terceros
        // Error retrieving third parties
        ERROR_OBTENER_TERCEROS: 'ACCOUNTING.CAUSACION.MESSAGES.ERRORS.ERROR_OBTENER_TERCEROS',

        // Error al exportar la plantilla
        // Error exporting template
        ERROR_EXPORTAR_PLANTILLA: 'ACCOUNTING.CAUSACION.MESSAGES.ERRORS.ERROR_EXPORTAR_PLANTILLA',

        // No se encontró la línea de asiento para actualizar
        // Entry line not found for update
        LINEA_ASIENTO_NO_ENCONTRADA:
          'ACCOUNTING.CAUSACION.MESSAGES.ERRORS.LINEA_ASIENTO_NO_ENCONTRADA',
      },
      WARNINGS: {
        // Cuentas contables no encontradas: {0}
        // Chart of accounts not found: {0}
        CUENTAS_NO_ENCONTRADAS: 'ACCOUNTING.CAUSACION.MESSAGES.WARNINGS.CUENTAS_NO_ENCONTRADAS',

        // No hay datos para exportar
        // No data to export
        NO_HAY_DATOS_EXPORTAR: 'ACCOUNTING.CAUSACION.MESSAGES.WARNINGS.NO_HAY_DATOS_EXPORTAR',

        // No hay deducción para editar
        // No deduction available to edit
        NO_HAY_DEDUCCION: 'ACCOUNTING.CAUSACION.MESSAGES.WARNINGS.NO_HAY_DEDUCCION',

        //Solo se pueden editar documentos en estado RECHAZADO
        //Solo se pueden eliminar documentos en estado RECHAZADO
        EDITAR_SOLO_RECHAZADO: 'ACCOUNTING.CAUSACION.ERROR.EDITAR_SOLO_RECHAZADO',
        ELIMINAR_SOLO_RECHAZADO: 'ACCOUNTING.CAUSACION.ERROR.ELIMINAR_SOLO_RECHAZADO',
      },

      HINTS: {
        // Debe ingresar al menos {0} caracteres
        // Enter at least {0} characters
        MINIMO_CARACTERES: 'ACCOUNTING.CAUSACION.MESSAGES.HINTS.MINIMO_CARACTERES',
      },
    },
  },

  ASIENTO: {
    COLUMNS: {
      AGREGAR_LINEA: 'ACCOUNTING.ASIENTO.BUTTON.AGREGAR_LINEA',
      CUENTA_CODIGO: 'ACCOUNTING.ASIENTO.COLUMNS.CUENTA_CODIGO',
      CUENTA_NOMBRE: 'ACCOUNTING.ASIENTO.COLUMNS.CUENTA_NOMBRE',
      DEBITO: 'ACCOUNTING.ASIENTO.COLUMNS.DEBITO',
      CREDITO: 'ACCOUNTING.ASIENTO.COLUMNS.CREDITO',
      BASE_DEDUCCION: 'ACCOUNTING.ASIENTO.COLUMNS.BASE_DEDUCCION',
      CENTRO_COSTOS: 'ACCOUNTING.ASIENTO.COLUMNS.CENTRO_COSTOS',
      TERCERO: 'ACCOUNTING.ASIENTO.COLUMNS.TERCERO',
    },
    PLACEHOLDER: {
      BUSCAR_CUENTA: 'ACCOUNTING.ASIENTO.PLACEHOLDER.BUSCAR_CUENTA',
      VALOR_DEFAULT: 'ACCOUNTING.ASIENTO.PLACEHOLDER.VALOR_DEFAULT',
      BUSCAR_CC: 'ACCOUNTING.ASIENTO.PLACEHOLDER.BUSCAR_CC',
      BUSCAR_TERCERO: 'ACCOUNTING.ASIENTO.PLACEHOLDER.BUSCAR_TERCERO',
    },
    TOOLTIP: {
      BUSCAR_CUENTA: 'ACCOUNTING.ASIENTO.TOOLTIP.BUSCAR_CUENTA',
      BUSCAR_CENTRO_COSTOS: 'ACCOUNTING.ASIENTO.TOOLTIP.BUSCAR_CENTRO_COSTOS',
      BUSCAR_TERCERO: 'ACCOUNTING.ASIENTO.TOOLTIP.BUSCAR_TERCERO',
    },
    ERROR: {
      REQUIRED: 'ACCOUNTING.ASIENTO.ERROR.REQUIRED',
      MIN_ZERO: 'ACCOUNTING.ASIENTO.ERROR.MIN_ZERO',
    },
  },

  ACCOUNTING_FORMAT: {
    TAB: {
      // Datos Generales
      // General Information
      GENERAL: 'ACCOUNTING.ACCOUNTING_FORMAT.TAB.GENERAL',

      // Cuentas Retenedoras
      // Withholding Accounts
      WITHHOLDING_ACCOUNTS: 'ACCOUNTING.ACCOUNTING_FORMAT.TAB.WITHHOLDING_ACCOUNTS',

      // Distribución por Centro de Costos
      // Cost Center Distribution
      COST_CENTER_DISTRIBUTION: 'ACCOUNTING.ACCOUNTING_FORMAT.TAB.COST_CENTER_DISTRIBUTION',
    },

    LABEL: {
      // Código
      // Code
      CODE: 'ACCOUNTING.ACCOUNTING_FORMAT.LABEL.CODE',

      // Nombre
      // Name
      NAME: 'ACCOUNTING.ACCOUNTING_FORMAT.LABEL.NAME',

      // Tipo de Operación
      // Operation type
      OPERATION_TYPE: 'ACCOUNTING.ACCOUNTING_FORMAT.LABEL.OPERATION_TYPE',
    },

    PLACEHOLDER: {
      // Código
      // Code
      CODE: 'ACCOUNTING.ACCOUNTING_FORMAT.PLACEHOLDER.CODE',

      // Nombre
      // Name
      NAME: 'ACCOUNTING.ACCOUNTING_FORMAT.PLACEHOLDER.NAME',

      // Seleccione un tipo de operación
      // Select an operation type
      OPERATION_TYPE: 'ACCOUNTING.ACCOUNTING_FORMAT.PLACEHOLDER.OPERATION_TYPE',
    },

    TOOLTIP: {
      // Código alfanumérico único del formato (máx. 10 caracteres)
      // Unique alphanumeric format code (max. 10 characters)
      CODE: 'ACCOUNTING.ACCOUNTING_FORMAT.TOOLTIP.CODE',

      // Nombre descriptivo del formato contable
      // Descriptive accounting format name
      NAME: 'ACCOUNTING.ACCOUNTING_FORMAT.TOOLTIP.NAME',

      // Seleccione el tipo de operación desde el maestro de conceptos
      // Select the operation type from the concepts catalog
      OPERATION_TYPE: 'ACCOUNTING.ACCOUNTING_FORMAT.TOOLTIP.OPERATION_TYPE',

      RESUME_SAVE: 'ACCOUNTING.ACCOUNTING_PARAMETERS.TOOLTIP.RESUME_SAVE', // Reanudando guardado...
      SAVING: 'ACCOUNTING.ACCOUNTING_PARAMETERS.TOOLTIP.SAVING', // Guardando...
    },
    MESSAGES: {
      SUCCESS: {
        ACCOUNT_SELECTED: 'ACCOUNTING.ACCOUNTING_FORMAT.MESSAGES.SUCCESS.ACCOUNT_SELECTED',
      },
    },
  },

  DISTRIBUTION_COST_CENTER: {
    LABEL: {
      // Tipo Centro de Costos
      // Cost center type
      COST_CENTER_TYPE: 'ACCOUNTING.DISTRIBUTION_COST_CENTER.LABEL.COST_CENTER_TYPE',

      // Centro de Costo
      // Cost center
      COST_CENTER: 'ACCOUNTING.DISTRIBUTION_COST_CENTER.LABEL.COST_CENTER',

      // Código Centro de Costos
      // Cost center code
      COST_CENTER_CODE: 'ACCOUNTING.DISTRIBUTION_COST_CENTER.LABEL.COST_CENTER_CODE',

      // Nombre Centro de Costos
      // Cost center name
      COST_CENTER_NAME: 'ACCOUNTING.DISTRIBUTION_COST_CENTER.LABEL.COST_CENTER_NAME',

      // Porcentaje
      // Percentage
      PERCENTAGE: 'ACCOUNTING.DISTRIBUTION_COST_CENTER.LABEL.PERCENTAGE',
    },

    PLACEHOLDER: {
      // Seleccione un tipo de centro de costo
      // Select a cost center type
      COST_CENTER_TYPE: 'ACCOUNTING.DISTRIBUTION_COST_CENTER.PLACEHOLDER.COST_CENTER_TYPE',

      // Seleccione un centro de costo
      // Select a cost center
      COST_CENTER: 'ACCOUNTING.DISTRIBUTION_COST_CENTER.PLACEHOLDER.COST_CENTER',

      // Seleccione un centro de costo
      // Select a cost center
      COST_CENTER_CODE: 'ACCOUNTING.DISTRIBUTION_COST_CENTER.PLACEHOLDER.COST_CENTER_CODE',

      // Seleccione un centro de costo
      // Select a cost center
      COST_CENTER_NAME: 'ACCOUNTING.DISTRIBUTION_COST_CENTER.PLACEHOLDER.COST_CENTER_NAME',

      // Porcentaje(%)
      // Percentage (%)
      PERCENTAGE: 'ACCOUNTING.DISTRIBUTION_COST_CENTER.PLACEHOLDER.PERCENTAGE',
    },

    TOOLTIP: {
      // Seleccione el tipo de centro de costo
      // Select the cost center type
      COST_CENTER_TYPE: 'ACCOUNTING.DISTRIBUTION_COST_CENTER.TOOLTIP.COST_CENTER_TYPE',

      // Seleccione el centro de costo
      // Select the cost center
      COST_CENTER: 'ACCOUNTING.DISTRIBUTION_COST_CENTER.TOOLTIP.COST_CENTER',

      // Código del centro de costos (automático)
      // Cost center code (automatic)
      COST_CENTER_CODE: 'ACCOUNTING.DISTRIBUTION_COST_CENTER.TOOLTIP.COST_CENTER_CODE',

      // Nombre del centro de costos (automático)
      // Cost center name (automatic)
      COST_CENTER_NAME: 'ACCOUNTING.DISTRIBUTION_COST_CENTER.TOOLTIP.COST_CENTER_NAME',

      // Porcentaje de distribución (0-100)
      // Distribution percentage (0-100)
      PERCENTAGE: 'ACCOUNTING.DISTRIBUTION_COST_CENTER.TOOLTIP.PERCENTAGE',
    },
  },

  ACCOUNTING_PARAMETERS: {
    LABEL: {
      PARAMETERS_TITLE: 'OPTIONS_ACCOUNTING_PARAMETERS', // Parámetros
      PARAMETERS_SUBTITLE: 'ACCOUNTING.PARAMETER.SUBTITLE', // Configuración general de la entidad
      PARAMETERS_SYSTEM_DATE: 'LAYOUT.SYSTEM_DATE', // Fecha del sistema
      PARAMETERS_LIB_EMPTY_MESSAGE: 'ACCOUNTING.PARAMETER.EMPTY_MESSAGE', // Cargando Parámetros
      PARAMETERS_LIB_EMPTY_DESCRIPTION: 'ACCOUNTING.PARAMETER.EMPTY_DESCRIPTION', // Espere Por favor...
      PARAMETERS_ENTITY_INFORMATION: 'ACCOUNTING.PARAMETER.ENTITY_INFORMATION',
      PARAMETERS_CONFIGURATION_DATA_LOADED_SUCCESSFULLY:
        'ACCOUNTING.PARAMETER.CONFIGURATION_DATA_LOADED_SUCCESSFULLY', // Datos cargados de configuración
      PARAMETERS_OPERATION: 'ACCOUNTING.PARAMETER.OPERATION_PARAMETERS', // Parámetros de operación
      PARAMETERS_CURRENT_SYSTEM_DATE_REQUIRED: 'ACCOUNTING.PARAMETER.CURRENT_SYSTEM_DATE_REQUIRED', // La fecha del Sistema es requerida
      PARAMETERS_AFFECTS_PUBLIC_BUDGET: 'ACCOUNTING.PARAMETER.AFFECTS_PUBLIC_BUDGET', // Afecta Presupuesto Público
      PARAMETERS_MULTIPLAN_ACCOUNTING: 'ACCOUNTING.PARAMETER.MULTIPLAN_ACCOUNTING', // Multiplan Contable
      PARAMETERS_APPROVAL_OF_CAUSATION: 'ACCOUNTING.PARAMETER.APPROVAL_OF_CAUSATION', // Aprobación de causación
      PARAMETERS_HANDLES_DEFERRED: 'ACCOUNTING.PARAMETER.HANDLES_DEFERRED', // Maneja diferidos
      PARAMETERS_AUTOMATIC_PROCESSES: 'ACCOUNTING.PARAMETER.AUTOMATIC_PROCESSES', // Procesos Automáticos
      PARAMETERS_AUTOMATIC_PROCESSES_TITLE: 'ACCOUNTING.PARAMETER.AUTOMATIC_PROCESSES_TITLE', // Se actualizan automáticamente
      PARAMETERS_FIRST_NAME: 'COLUMNS.FIRST_NAME', // Nombre
      PARAMETERS_NIT: 'VALUES.NIT', // Número de Identificación Tributaria (NIT) de la entidad según registro mercantil
      PARAMETERS_VALIDITY: 'COLUMNS.VALIDITY', // Vigencia
      PARAMETERS_DEFERRED_MONTH: 'ACCOUNTING.PARAMETER.DEFERRED_MONTH', // Mes diferido
      PARAMETERS_LAST_CLOSED_MONTH: 'ACCOUNTING.PARAMETER.LAST_CLOSED_MONTH', // Último mes cerrado
      PARAMETERS_DEPRECIATION_MONTH: 'ACCOUNTING.PARAMETER.DEPRECIATION_MONTH', // Mes de depreciación
      PARAMETERS_NOT_DEFINED: 'ACCOUNTING.PARAMETER.NOT_DEFINED', // No definido
    },

    TOOLTIP: {
      PARAMETERS_CURRENT_SYSTEM_DATE: 'ACCOUNTING.PARAMETER.CURRENT_SYSTEM_DATE_TOOLTIP', // Fecha actual del sistema para operaciones contables
      PARAMETERS_AFFECTS_PUBLIC_BUDGET: 'ACCOUNTING.PARAMETER.AFFECTS_PUBLIC_BUDGET_TOOLTIP', // Indica si las operaciones afectan el presupuesto público
      PARAMETERS_MULTIPLAN_ACCOUNTING: 'ACCOUNTING.PARAMETER.MULTIPLAN_ACCOUNTING_TOOLTIP', // Habilita la gestión de múltiples planes contables
      PARAMETERS_APPROVAL_OF_CAUSATION: 'ACCOUNTING.PARAMETER.APPROVAL_OF_CAUSATION_TOOLTIP', // Requiere aprobación para los procesos de causación contable
      PARAMETERS_HANDLES_DEFERRED: 'ACCOUNTING.PARAMETER.HANDLES_DEFERRED_TOOLTIP', // Indica si la entidad maneja procesos de diferidos contables
      PARAMETERS_AUTOMATIC_PROCESSES: 'ACCOUNTING.PARAMETER.AUTOMATIC_PROCESSES_TOOLTIP', // Indica si la entidad maneja procesos automáticos
      PARAMETERS_FIRST_NAME: 'COLUMNS.FIRST_NAME_TOOLTIP', // Nombre legal de la entidad según registro mercantil
      PARAMETERS_NIT: 'VALUES.NIT_TOOLTIP', // Número de Identificación Tributaria de la entidad
      PARAMETERS_VALIDITY: 'COLUMNS.VALIDITY_TOOLTIP', // Año contable actual de la entidad
      PARAMETERS_DEFERRED_MONTH: 'ACCOUNTING.PARAMETER.DEFERRED_MONTH_TOOLTIP', // Mes actual para el proceso de diferidos contables
      PARAMETERS_LAST_CLOSED_MONTH: 'ACCOUNTING.PARAMETER.LAST_CLOSED_MONTH_TOOLTIP', // Último período contable cerrado. La fecha del sistema no puede ser inferior a este valor
      PARAMETERS_DEPRECIATION_MONTH: 'ACCOUNTING.PARAMETER.DEPRECIATION_MONTH_TOOLTIP', // Mes actual para el cálculo de depreciaciones de activos fijos
    },

    ACTION: {
      REFRESH: 'ACTIONS.REFRESH', // Refrescar
      CANCEL: 'ACTIONS.CANCEL', // Cancelar
      SAVE: 'ACTIONS.SAVE', // Guardar
      SAVE_RELOAD: 'ACTIONS.SAVE_RELOAD', // Reanudando guardado...
      SAVING: 'ACTIONS.SAVING', // Guardando...
      PENDING_SAVE: 'ACTIONS.PENDING_SAVE', // Hay una operación de guardado pendiente. Reanudando...
      SAVING_CHANGES: 'ACTIONS.SAVING_CHANGES', // Guardando cambios...
      SAVING_CHANGES_RELOAD: 'ACTIONS.SAVING_CHANGES_RELOAD', // Guardando cambios. Por favor no cierre esta página...
      SAVING_CHANGES_RELOAD_PENDING: 'ACTIONS.SAVING_CHANGES_RELOAD_PENDING', // Hay una operación de guardado pendiente. Reanudando...
      SAVING_PARAMETERS: 'ACTIONS.CARGANDO_PARAMETROS', // Cargando parámetros...
      CREATE: 'ACTIONS.CREATE', //Crear
      EDIT: 'ACTIONS.EDIT', //Editar
      VIEW: 'ACTIONS.VIEW', //Consultar
      MODIFY: 'ACTIONS.MODIFY', //Modificar
      DELETE: 'ACTIONS.DELETE', //Eliminar
      CONSULT: 'ACTIONS.CONSULT', //Consultar
    },

    CONFIRM_DIALOGS: {
      REFRESH: {
        TITLE: 'ACTIONS.CONFIRM_REFRESH.TITLE', // Cambios sin guardar
        MESSAGE: 'ACTIONS.CONFIRM_REFRESH.MESSAGE', // Tiene cambios sin guardar. ¿Está seguro de que desea salir? Los cambios se perderán.
        CONFIRM_LABEL: 'ACTIONS.CONFIRM_REFRESH.CONFIRM', // 'Sí, refrescar
        CANCEL_LABEL: 'ACTIONS.CONFIRM_REFRESH.CANCEL', // Cancelar
      },
      CAN_DEACTIVATE: {
        TITLE: 'ACTIONS.CONFIRM_DEACTIVATE.TITLE', // Cambios sin guardar
        MESSAGE: 'ACTIONS.CONFIRM_DEACTIVATE.MESSAGE', // Tiene cambios sin guardar. ¿Está seguro de que desea salir? Los cambios se perderán.
        CONFIRM_LABEL: 'ACTIONS.CONFIRM_DEACTIVATE.CONFIRM', // Continuar editando
        CANCEL_LABEL: 'ACTIONS.CONFIRM_DEACTIVATE.CANCEL', // Sí, salir
      },
    },
  },

  ANNULLMENT: {
    TITLE: {
      LIST: 'OPTIONS_JOURNAL_ENTRY_ANNULMENT',
      VIEW: 'ACCOUNTING.ANNULLMENT.TITLE.VIEW',
      BULK_ANNULLMENT: 'ACCOUNTING.ANNULLMENT.TITLE.BULK_ANNULLMENT',
      CONFIRM_ANNULLMENT: 'ACCOUNTING.ANNULLMENT.TITLE.CONFIRM_ANNULLMENT',
    },

    SUBTITLE: {
      LIST: 'ACCOUNTING.ANNULLMENT.SUBTITLE.LIST',
      VIEW: 'ACCOUNTING.ANNULLMENT.SUBTITLE.VIEW',
      EMPTY: 'ACCOUNTING.ANNULLMENT.SUBTITLE.EMPTY',
    },

    COUNTER: {
      SINGULAR: 'ACCOUNTING.ANNULLMENT.COUNTER.SINGULAR',
      PLURAL: 'ACCOUNTING.ANNULLMENT.COUNTER.PLURAL',
      SHOWING: 'ACCOUNTING.ANNULLMENT.COUNTER.SHOWING',
      OF: 'ACCOUNTING.ANNULLMENT.COUNTER.OF',
    },

    PLACEHOLDER: {
      SEARCH: 'ACCOUNTING.ANNULLMENT.PLACEHOLDER.SEARCH',
      DATE_START: 'ACCOUNTING.ANNULLMENT.PLACEHOLDER.DATE_START',
      DATE_END: 'ACCOUNTING.ANNULLMENT.PLACEHOLDER.DATE_END',
      ANNULLMENT_REASON: 'ACCOUNTING.ANNULLMENT.PLACEHOLDER.ANNULLMENT_REASON',
    },

    LABEL: {
      ANNULLMENT_REASON: 'ACCOUNTING.ANNULLMENT.LABEL.ANNULLMENT_REASON',
      CODE: 'ACCOUNTING.ANNULLMENT.LABEL.CODE',
      CONCEPT: 'ACCOUNTING.ANNULLMENT.LABEL.CONCEPT',
      TYPE: 'ACCOUNTING.ANNULLMENT.LABEL.TYPE',
      IDENTIFICATION: 'ACCOUNTING.ANNULLMENT.LABEL.IDENTIFICATION',
      BUSINESS_NAME: 'ACCOUNTING.ANNULLMENT.LABEL.BUSINESS_NAME',
      DOC_NUMBER: 'ACCOUNTING.ANNULLMENT.LABEL.DOC_NUMBER',
      DOC_DATE: 'ACCOUNTING.ANNULLMENT.LABEL.DOC_DATE',
      TOTAL_DEBIT: 'ACCOUNTING.ANNULLMENT.LABEL.TOTAL_DEBIT',
      TOTAL_CREDIT: 'ACCOUNTING.ANNULLMENT.LABEL.TOTAL_CREDIT',
      DIFFERENCE: 'ACCOUNTING.ANNULLMENT.LABEL.DIFFERENCE',
      BALANCED: 'ACCOUNTING.ANNULLMENT.LABEL.BALANCED',
      NOT_BALANCED: 'ACCOUNTING.ANNULLMENT.LABEL.NOT_BALANCED',

      // Etiquetas para el modo vista
      VIEW_TITLE: 'ACCOUNTING.ANNULLMENT.LABEL.VIEW_TITLE',
      ENTRY_DATA: 'ACCOUNTING.ANNULLMENT.LABEL.ENTRY_DATA',
      ENTRY_DETAIL: 'ACCOUNTING.ANNULLMENT.LABEL.ENTRY_DETAIL',
      LOADING_DETAIL: 'ACCOUNTING.ANNULLMENT.LABEL.LOADING_DETAIL',
      NO_IDENTIFICATION: 'ACCOUNTING.ANNULLMENT.LABEL.NO_IDENTIFICATION',
      BUSINESS_NAME_FULL: 'ACCOUNTING.ANNULLMENT.LABEL.BUSINESS_NAME_FULL',
      DOC_NUMBER_FULL: 'ACCOUNTING.ANNULLMENT.LABEL.DOC_NUMBER_FULL',
      ENTRY_CODE: 'ACCOUNTING.ANNULLMENT.LABEL.ENTRY_CODE',
      CONCEPT_FULL: 'ACCOUNTING.ANNULLMENT.LABEL.CONCEPT_FULL',
      TYPE_FULL: 'ACCOUNTING.ANNULLMENT.LABEL.TYPE_FULL',
      DESCRIPTION_FULL: 'ACCOUNTING.ANNULLMENT.LABEL.DESCRIPTION_FULL',
      ACCOUNT_CODE: 'ACCOUNTING.ANNULLMENT.LABEL.ACCOUNT_CODE',
      ACCOUNT_NAME: 'ACCOUNTING.ANNULLMENT.LABEL.ACCOUNT_NAME',
      DEBIT_VALUE: 'ACCOUNTING.ANNULLMENT.LABEL.DEBIT_VALUE',
      CREDIT_VALUE: 'ACCOUNTING.ANNULLMENT.LABEL.CREDIT_VALUE',
      DEDUCTION_BASE: 'ACCOUNTING.ANNULLMENT.LABEL.DEDUCTION_BASE',
      BANK: 'ACCOUNTING.ANNULLMENT.LABEL.BANK',
      COST_CENTER: 'ACCOUNTING.ANNULLMENT.LABEL.COST_CENTER',
      THIRD_PARTY_ID: 'ACCOUNTING.ANNULLMENT.LABEL.THIRD_PARTY_ID',
      THIRD_PARTY_NAME: 'ACCOUNTING.ANNULLMENT.LABEL.THIRD_PARTY_NAME',
      AUTO_GENERATED: 'ACCOUNTING.ANNULLMENT.LABEL.AUTO_GENERATED',
      ENTRY_DESCRIPTION: 'ACCOUNTING.ANNULLMENT.LABEL.ENTRY_DESCRIPTION',
    },

    COLUMNS: {
      CODE: 'ACCOUNTING.ANNULLMENT.COLUMNS.CODE',
      CONCEPT: 'ACCOUNTING.ANNULLMENT.COLUMNS.CONCEPT',
      TYPE: 'ACCOUNTING.ANNULLMENT.COLUMNS.TYPE',
      IDENTIFICATION: 'ACCOUNTING.ANNULLMENT.COLUMNS.IDENTIFICATION',
      BUSINESS_NAME: 'ACCOUNTING.ANNULLMENT.COLUMNS.BUSINESS_NAME',
      DOC_NUMBER: 'ACCOUNTING.ANNULLMENT.COLUMNS.DOC_NUMBER',
      DOC_DATE: 'ACCOUNTING.ANNULLMENT.COLUMNS.DOC_DATE',
    },

    ACTION: {
      REFRESH: 'ACTIONS.REFRESH',
      CANCEL: 'ACTIONS.CANCEL',
      SAVE: 'ACTIONS.SAVE',
      SAVE_RELOAD: 'ACTIONS.SAVE_RELOAD',
      SAVING: 'ACTIONS.SAVING',
      PENDING_SAVE: 'ACTIONS.PENDING_SAVE',
      SAVING_CHANGES_RELOAD: 'ACTIONS.SAVING_CHANGES_RELOAD',
      ANNULL: 'ACTION.ANNUL',
      BACK: 'ACTIONS.BACK',
      CONFIRM_ANNULL: 'ACTION.ANNUL',
      CONSULT: 'ACTIONS.ANNULLMENT.BUTTON.CONSULT',
    },

    EMPTY: {
      MESSAGE: 'ACCOUNTING.ANNULLMENT.EMPTY.MESSAGE',
      DESCRIPTION: 'ACCOUNTING.ANNULLMENT.EMPTY.DESCRIPTION',
    },

    CONFIRM_DIALOG: {
      TITLE: 'ACCOUNTING.ANNULLMENT.CONFIRM_DIALOG.TITLE',
      DESCRIPTION: 'ACCOUNTING.ANNULLMENT.CONFIRM_DIALOG.DESCRIPTION',
      CONFIRM_LABEL: 'ACCOUNTING.ANNULLMENT.CONFIRM_DIALOG.CONFIRM_LABEL',
      CANCEL_LABEL: 'ACCOUNTING.ANNULLMENT.CONFIRM_DIALOG.CANCEL_LABEL',
      REASON_REQUIRED: 'ACCOUNTING.ANNULLMENT.CONFIRM_DIALOG.REASON_REQUIRED',
      REASON_MAX_LENGTH: 'ACCOUNTING.ANNULLMENT.CONFIRM_DIALOG.REASON_MAX_LENGTH',
      NO_DOCUMENTS: 'ACCOUNTING.ANNULLMENT.CONFIRM_DIALOG.NO_DOCUMENTS',
    },

    LOADING: {
      DETAIL: 'ACCOUNTING.ANNULLMENT.LOADING.DETAIL',
    },

    VALIDATION: {
      SEARCH_MIN_LENGTH: 'ACCOUNTING.ANNULLMENT.VALIDATION.SEARCH_MIN_LENGTH',
      SEARCH_MAX_LENGTH: 'ACCOUNTING.ANNULLMENT.VALIDATION.SEARCH_MAX_LENGTH',
      DATE_INVALID: 'ACCOUNTING.ANNULLMENT.VALIDATION.DATE_INVALID',
    },

    ALERT: {
      ERROR_TITLE: 'ACCOUNTING.ANNULLMENT.ALERT.ERROR_TITLE',
      SUCCESS_TITLE: 'ACCOUNTING.ANNULLMENT.ALERT.SUCCESS_TITLE',
      ERROR_LOADING_DETAIL: 'ACCOUNTING.ANNULLMENT.ALERT.ERROR_LOADING_DETAIL',
    },

    TAB: {
      FACTURA: 'ACCOUNTING.ANNULLMENT.TAB.FACTURA',
      CAUSACION_CONTABLE: 'ACCOUNTING.ANNULLMENT.TAB.CAUSACION_CONTABLE',
      SALDOS_CUENTA: 'ACCOUNTING.ANNULLMENT.TAB.SALDOS_CUENTA',
      ORDEN_PAGO: 'ACCOUNTING.ANNULLMENT.TAB.ORDEN_PAGO',
    },

    SECTION: {
      ARTICULOS: 'ACCOUNTING.ANNULLMENT.SECTION.ARTICULOS',
      DETALLE_ASIENTO: 'ACCOUNTING.ANNULLMENT.SECTION.DETALLE_ASIENTO',
      RESUMEN: 'ACCOUNTING.ANNULLMENT.SECTION.RESUMEN',
    },

    DETAIL: {
      NO_IDENTIFICACION: 'ACCOUNTING.ANNULLMENT.DETAIL.NO_IDENTIFICACION',
      NOMBRE_RAZON_SOCIAL: 'ACCOUNTING.ANNULLMENT.DETAIL.NOMBRE_RAZON_SOCIAL',
      NUMERO_DOCUMENTO: 'ACCOUNTING.ANNULLMENT.DETAIL.NUMERO_DOCUMENTO',
      FECHA_EXPEDICION: 'ACCOUNTING.ANNULLMENT.DETAIL.FECHA_EXPEDICION',
      FECHA_VENCIMIENTO: 'ACCOUNTING.ANNULLMENT.DETAIL.FECHA_VENCIMIENTO',
      FECHA_RADICACION: 'ACCOUNTING.ANNULLMENT.DETAIL.FECHA_RADICACION',
      GENERA_OP: 'ACCOUNTING.ANNULLMENT.DETAIL.GENERA_OP',
      TOTAL_ANTES_IMPUESTO: 'ACCOUNTING.ANNULLMENT.DETAIL.TOTAL_ANTES_IMPUESTO',
      TOTAL_IMPUESTO: 'ACCOUNTING.ANNULLMENT.DETAIL.TOTAL_IMPUESTO',
      TOTAL_FACTURA: 'ACCOUNTING.ANNULLMENT.DETAIL.TOTAL_FACTURA',
      DESCRIPCION: 'ACCOUNTING.ANNULLMENT.DETAIL.DESCRIPCION',
      ASIENTO_HEADER: 'ACCOUNTING.ANNULLMENT.DETAIL.ASIENTO_HEADER',
    },

    DETAIL_TABLE: {
      ARTICULO: {
        CODE: 'ACCOUNTING.ANNULLMENT.DETAIL_TABLE.ARTICULO.CODE',
        NAME: 'ACCOUNTING.ANNULLMENT.DETAIL_TABLE.ARTICULO.NAME',
        QUANTITY: 'ACCOUNTING.ANNULLMENT.DETAIL_TABLE.ARTICULO.QUANTITY',
        UNIT_VALUE: 'ACCOUNTING.ANNULLMENT.DETAIL_TABLE.ARTICULO.UNIT_VALUE',
        TOTAL_VALUE: 'ACCOUNTING.ANNULLMENT.DETAIL_TABLE.ARTICULO.TOTAL_VALUE',
        TAX_PERCENTAGE: 'ACCOUNTING.ANNULLMENT.DETAIL_TABLE.ARTICULO.TAX_PERCENTAGE',
        VALUE_BEFORE_TAX: 'ACCOUNTING.ANNULLMENT.DETAIL_TABLE.ARTICULO.VALUE_BEFORE_TAX',
        TAX_VALUE: 'ACCOUNTING.ANNULLMENT.DETAIL_TABLE.ARTICULO.TAX_VALUE',
      },
      MOVIMIENTO: {
        ACCOUNT_CODE: 'ACCOUNTING.ANNULLMENT.DETAIL_TABLE.MOVIMIENTO.ACCOUNT_CODE',
        ACCOUNT_NAME: 'ACCOUNTING.ANNULLMENT.DETAIL_TABLE.MOVIMIENTO.ACCOUNT_NAME',
        DEBIT: 'ACCOUNTING.ANNULLMENT.DETAIL_TABLE.MOVIMIENTO.DEBIT',
        CREDIT: 'ACCOUNTING.ANNULLMENT.DETAIL_TABLE.MOVIMIENTO.CREDIT',
        DEDUCTION_BASE: 'ACCOUNTING.ANNULLMENT.DETAIL_TABLE.MOVIMIENTO.DEDUCTION_BASE',
        COST_CENTER_CODE: 'ACCOUNTING.ANNULLMENT.DETAIL_TABLE.MOVIMIENTO.COST_CENTER_CODE',
        THIRD_PARTY_ID: 'ACCOUNTING.ANNULLMENT.DETAIL_TABLE.MOVIMIENTO.THIRD_PARTY_ID',
        THIRD_PARTY_NAME: 'ACCOUNTING.ANNULLMENT.DETAIL_TABLE.MOVIMIENTO.THIRD_PARTY_NAME',
        BANK: 'ACCOUNTING.ANNULLMENT.DETAIL_TABLE.MOVIMIENTO.BANK',
        DOC_NUMBER_SHORT: 'ACCOUNTING.ANNULLMENT.DETAIL_TABLE.MOVIMIENTO.DOC_NUMBER_SHORT',
        DEBIT_VALUE: 'ACCOUNTING.ANNULLMENT.DETAIL_TABLE.MOVIMIENTO.DEBIT_VALUE',
        CREDIT_VALUE: 'ACCOUNTING.ANNULLMENT.DETAIL_TABLE.MOVIMIENTO.CREDIT_VALUE',
      },
    },

    TOOLTIP: {
      NO_IDENTIFICATION: 'ACCOUNTING.ANNULLMENT.TOOLTIP.NO_IDENTIFICATION',
      BUSINESS_NAME: 'ACCOUNTING.ANNULLMENT.TOOLTIP.BUSINESS_NAME',
      DOC_NUMBER: 'ACCOUNTING.ANNULLMENT.TOOLTIP.DOC_NUMBER',
      ENTRY_CODE: 'ACCOUNTING.ANNULLMENT.TOOLTIP.ENTRY_CODE',
      CONCEPT: 'ACCOUNTING.ANNULLMENT.TOOLTIP.CONCEPT',
      TYPE: 'ACCOUNTING.ANNULLMENT.TOOLTIP.TYPE',
      DESCRIPTION: 'ACCOUNTING.ANNULLMENT.TOOLTIP.DESCRIPTION',
    },

    ERROR: {
      REASON_REQUIRED: 'Se debe ingresar un motivo de anulación',
      REASON_MAX_LENGTH: 'El motivo de anulación no puede exceder los 300 caracteres',
      TYPE_ANNULMENT_CONCEPT_NOT_EXISTS:
        'Para el Concepto no existe Tipo de Asiento de Anulación, debe crearlo antes de realizar el proceso de anulación',
      BANK_CLOSED:
        'El asiento no se puede anular porque se afectaría el saldo de bancos y para la fecha los bancos están cerrados',
      OVERDRAFT_NOT_ALLOWED:
        'El asiento no se puede anular porque se afectaría el saldo de bancos y se sobregiraría',
      BATCH_ROLLBACK:
        'Error en la anulación masiva. El proceso ha sido revertido. Verifique los mensajes anteriores.',
      EMPTY_LIST: 'No se encontraron asientos para anular en el rango seleccionado',
      OUT_OF_VIGENCIA: 'El rango de fechas debe estar dentro de la vigencia activa',
      ANNULMENT_NOT_ALLOWED: 'No se permite anular este asiento',
      DOCUMENT_ALREADY_ANNULLED: 'El asiento ya ha sido anulado previamente',
      ENTRY_NOT_FOUND: 'No se encontró el asiento solicitado',
    },
  },

  DEPRECIATION: {
    COUNTER: {
      LABEL_SINGULAR: 'ACCOUNTING.DEPRECIATION.COUNTER.LABEL_SINGULAR',
      LABEL_PLURAL: 'ACCOUNTING.DEPRECIATION.COUNTER.LABEL_PLURAL',
    },

    EMPTY: {
      MESSAGE: 'ACCOUNTING.DEPRECIATION.EMPTY.MESSAGE',
      DESCRIPTION: 'ACCOUNTING.DEPRECIATION.EMPTY.DESCRIPTION',
    },

    LABEL: {
      TIPO_ASIENTO: 'ACCOUNTING.DEPRECIATION.LABEL.TIPO_ASIENTO',
      PERIOD: 'ACCOUNTING.DEPRECIATION.LABEL.PERIOD',
      CONSECUTIVO_ASIENTO: 'ACCOUNTING.DEPRECIATION.LABEL.CONSECUTIVO_ASIENTO',
      USUARIO_ELABORA: 'ACCOUNTING.DEPRECIATION.LABEL.USUARIO_ELABORA',
      FECHA_ASIENTO: 'ACCOUNTING.DEPRECIATION.LABEL.FECHA_ASIENTO',
      FECHA_REGISTRO: 'ACCOUNTING.DEPRECIATION.LABEL.FECHA_REGISTRO',
      OBSERVATIONS: 'ACCOUNTING.DEPRECIATION.LABEL.OBSERVATIONS',
    },
    TOOLTIP: {
      TIPO_ASIENTO: 'ACCOUNTING.DEPRECIATION.TOOLTIP.TIPO_ASIENTO',
      MES: 'ACCOUNTING.DEPRECIATION.TOOLTIP.MES',
      CONSECUTIVO_ASIENTO: 'ACCOUNTING.DEPRECIATION.TOOLTIP.CONSECUTIVO_ASIENTO',
      USUARIO_ELABORA: 'ACCOUNTING.DEPRECIATION.TOOLTIP.USUARIO_ELABORA',
      FECHA_ASIENTO: 'ACCOUNTING.DEPRECIATION.TOOLTIP.FECHA_ASIENTO',
      FECHA_REGISTRO: 'ACCOUNTING.DEPRECIATION.TOOLTIP.FECHA_REGISTRO',
      DESCRIPCION: 'ACCOUNTING.DEPRECIATION.TOOLTIP.DESCRIPCION',
    },
    TITLE: {
      LIST: 'ACCOUNTING.DEPRECIATION.TITLE.LIST',
      CREATE: 'ACCOUNTING.DEPRECIATION.TITLE.CREATE',
      VIEW: 'ACCOUNTING.DEPRECIATION.TITLE.VIEW',
    },
    SUBTITLE: {
      LIST: 'ACCOUNTING.DEPRECIATION.SUBTITLE.LIST',
      CREATE: 'ACCOUNTING.DEPRECIATION.SUBTITLE.CREATE',
      VIEW: 'ACCOUNTING.DEPRECIATION.SUBTITLE.VIEW',
    },
    COLUMN: {
      DEPRECIATION_AMOUNT: 'ACCOUNTING.DEPRECIATION.COLUMN.DEPRECIATION_AMOUNT', //Valor Diferido
    },
    DEFERRED_MONTH_TABLE: {
      COLUMN: {
        DOCUMENT: 'ACCOUNTING.DEPRECIATION.COUNTER.LABEL_SINGULAR',
        DEBIT_ACCOUNT: 'ACCOUNTING.DEPRECIATION.DEFERRED_MONTH_TABLE.COLUMN.DEBIT_ACCOUNT', // Cuenta Débito, Debit account

        CREDIT_ACCOUNT: 'ACCOUNTING.DEPRECIATION.DEFERRED_MONTH_TABLE.COLUMN.CREDIT_ACCOUNT', // Cuenta Crédito, Credit account

        IDENTIFICATION_NUMBER:
          'ACCOUNTING.DEPRECIATION.DEFERRED_MONTH_TABLE.COLUMN.IDENTIFICATION_NUMBER', // N. Identificación, Identification number

        NAME_OR_BUSINESS_NAME:
          'ACCOUNTING.DEPRECIATION.DEFERRED_MONTH_TABLE.COLUMN.NAME_OR_BUSINESS_NAME', // Nombre o Razón Social, Name or business name

        COST_CENTER: 'ACCOUNTING.DEPRECIATION.DEFERRED_MONTH_TABLE.COLUMN.COST_CENTER', // Centro de Costos, Cost center

        DEBIT_VALUE: 'ACCOUNTING.DEPRECIATION.DEFERRED_MONTH_TABLE.COLUMN.DEBIT_VALUE', // Valor Débito, Debit value

        CREDIT_VALUE: 'ACCOUNTING.ENTRY_DEFERRED.DEFERRED_MONTH_TABLE.COLUMN.CREDIT_VALUE', // Valor Crédito, Credit value
      },
    },
  },
  ENTRY_DEFERRED: {
    COUNTER: {
      LABEL_SINGULAR: 'ACCOUNTING.ENTRY_DEFERRED.COUNTER.LABEL_SINGULAR',
      LABEL_PLURAL: 'ACCOUNTING.ENTRY_DEFERRED.COUNTER.LABEL_PLURAL',
    },

    EMPTY: {
      MESSAGE: 'ACCOUNTING.ENTRY_DEFERRED.EMPTY.MESSAGE',
      DESCRIPTION: 'ACCOUNTING.ENTRY_DEFERRED.EMPTY.DESCRIPTION',
    },

    LABEL: {
      TIPO_ASIENTO: 'ACCOUNTING.ENTRY_DEFERRED.LABEL.TIPO_ASIENTO',
      MES: 'ACCOUNTING.ENTRY_DEFERRED.LABEL.MES',
      CONSECUTIVO_ASIENTO: 'ACCOUNTING.ENTRY_DEFERRED.LABEL.CONSECUTIVO_ASIENTO',
      USUARIO_ELABORA: 'ACCOUNTING.ENTRY_DEFERRED.LABEL.USUARIO_ELABORA',
      FECHA_ASIENTO: 'ACCOUNTING.ENTRY_DEFERRED.LABEL.FECHA_ASIENTO',
      FECHA_REGISTRO: 'ACCOUNTING.ENTRY_DEFERRED.LABEL.FECHA_REGISTRO',
      DESCRIPCION: 'ACCOUNTING.ENTRY_DEFERRED.LABEL.DESCRIPCION',
    },
    TOOLTIP: {
      TIPO_ASIENTO: 'ACCOUNTING.ENTRY_DEFERRED.TOOLTIP.TIPO_ASIENTO',
      MES: 'ACCOUNTING.ENTRY_DEFERRED.TOOLTIP.MES',
      CONSECUTIVO_ASIENTO: 'ACCOUNTING.ENTRY_DEFERRED.TOOLTIP.CONSECUTIVO_ASIENTO',
      USUARIO_ELABORA: 'ACCOUNTING.ENTRY_DEFERRED.TOOLTIP.USUARIO_ELABORA',
      FECHA_ASIENTO: 'ACCOUNTING.ENTRY_DEFERRED.TOOLTIP.FECHA_ASIENTO',
      FECHA_REGISTRO: 'ACCOUNTING.ENTRY_DEFERRED.TOOLTIP.FECHA_REGISTRO',
      DESCRIPCION: 'ACCOUNTING.ENTRY_DEFERRED.TOOLTIP.DESCRIPCION',
    },
    TITLE: {
      LIST: 'ACCOUNTING.ENTRY_DEFERRED.TITLE.LIST',
      CREATE: 'ACCOUNTING.ENTRY_DEFERRED.TITLE.CREATE',
      VIEW: 'ACCOUNTING.ENTRY_DEFERRED.TITLE.VIEW',
    },
    SUBTITLE: {
      LIST: 'ACCOUNTING.ENTRY_DEFERRED.SUBTITLE.LIST',
      CREATE: 'ACCOUNTING.ENTRY_DEFERRED.SUBTITLE.CREATE',
      VIEW: 'ACCOUNTING.ENTRY_DEFERRED.SUBTITLE.VIEW',
    },
    COLUMN: {
      DEFERRED_AMOUNT: 'ACCOUNTING.ENTRY_DEFERRED.COLUMN.DEFERRED_AMOUNT', //Valor Diferido
    },
    DEFERRED_MONTH_TABLE: {
      COLUMN: {
        DOCUMENT: 'ACCOUNTING.ENTRY_DEFERRED.COUNTER.LABEL_SINGULAR',
        DEBIT_ACCOUNT: 'ACCOUNTING.ENTRY_DEFERRED.DEFERRED_MONTH_TABLE.COLUMN.DEBIT_ACCOUNT', // Cuenta Débito, Debit account

        CREDIT_ACCOUNT: 'ACCOUNTING.ENTRY_DEFERRED.DEFERRED_MONTH_TABLE.COLUMN.CREDIT_ACCOUNT', // Cuenta Crédito, Credit account

        IDENTIFICATION_NUMBER:
          'ACCOUNTING.ENTRY_DEFERRED.DEFERRED_MONTH_TABLE.COLUMN.IDENTIFICATION_NUMBER', // N. Identificación, Identification number

        NAME_OR_BUSINESS_NAME:
          'ACCOUNTING.ENTRY_DEFERRED.DEFERRED_MONTH_TABLE.COLUMN.NAME_OR_BUSINESS_NAME', // Nombre o Razón Social, Name or business name

        COST_CENTER: 'ACCOUNTING.ENTRY_DEFERRED.DEFERRED_MONTH_TABLE.COLUMN.COST_CENTER', // Centro de Costos, Cost center

        DEBIT_VALUE: 'ACCOUNTING.ENTRY_DEFERRED.DEFERRED_MONTH_TABLE.COLUMN.DEBIT_VALUE', // Valor Débito, Debit value

        CREDIT_VALUE: 'ACCOUNTING.ENTRY_DEFERRED.DEFERRED_MONTH_TABLE.COLUMN.CREDIT_VALUE', // Valor Crédito, Credit value
      },
    },
  },
  //TERCEROS
  THIRD_PARTY: {
    // ============================================================
    // 1. Claves de tabla y columnas
    // ============================================================
    COLUMNS: {
      STATUS: 'ACCOUNTING.THIRD_PARTY.COLUMNS.STATUS',
    },
    TABLE: {
      VINCULOS: {
        TYPE: 'ACCOUNTING.THIRD_PARTY.TABLE.VINCULOS.TYPE',
        REGISTRATION_DATE: 'ACCOUNTING.THIRD_PARTY.TABLE.VINCULOS.REGISTRATION_DATE',
        CONTRALORIA_CODE: 'ACCOUNTING.THIRD_PARTY.TABLE.VINCULOS.CONTRALORIA_CODE',
        SUP_BANCARIA_CODE: 'ACCOUNTING.THIRD_PARTY.TABLE.VINCULOS.SUP_BANCARIA_CODE',
      },
      BANK_ACCOUNTS: {
        BANK: 'ACCOUNTING.THIRD_PARTY.TABLE.BANK_ACCOUNTS.BANK',
        ACCOUNT_TYPE: 'ACCOUNTING.THIRD_PARTY.TABLE.BANK_ACCOUNTS.ACCOUNT_TYPE',
        ACCOUNT_NUMBER: 'ACCOUNTING.THIRD_PARTY.TABLE.BANK_ACCOUNTS.ACCOUNT_NUMBER',
      },
    },

    // ============================================================
    // 2. Títulos y subtítulos
    // ============================================================
    TITLE: {
      LIST: 'ACCOUNTING.THIRD_PARTY.TITLE.LIST',
      CREATE: 'ACCOUNTING.THIRD_PARTY.TITLE.CREATE',
      EDIT: 'ACCOUNTING.THIRD_PARTY.TITLE.EDIT',
      VIEW: 'ACCOUNTING.THIRD_PARTY.TITLE.VIEW',
    },
    SUBTITLE: {
      LIST: 'ACCOUNTING.THIRD_PARTY.SUBTITLE.LIST',
      CREATE: 'ACCOUNTING.THIRD_PARTY.SUBTITLE.CREATE',
      EDIT: 'ACCOUNTING.THIRD_PARTY.SUBTITLE.EDIT',
      VIEW: 'ACCOUNTING.THIRD_PARTY.SUBTITLE.VIEW',
    },

    // ============================================================
    // 3. Formulario - Labels generales
    // ============================================================
    FORM: {
      DOCUMENT_NUMBER: 'ACCOUNTING.THIRD_PARTY.FORM.DOCUMENT_NUMBER',
      DOCUMENT_TYPE: 'ACCOUNTING.THIRD_PARTY.FORM.DOCUMENT_TYPE',
      FULL_NAME: 'ACCOUNTING.THIRD_PARTY.FORM.FULL_NAME',
    },

    // ============================================================
    // 4. Placeholders, empty state y search
    // ============================================================
    SEARCH_PLACEHOLDER: 'ACCOUNTING.THIRD_PARTY.SEARCH_PLACEHOLDER',
    EMPTY: {
      MESSAGE: 'ACCOUNTING.THIRD_PARTY.EMPTY.MESSAGE',
      DESCRIPTION: 'ACCOUNTING.THIRD_PARTY.EMPTY.DESCRIPTION',
    },

    // ============================================================
    // 5. Opciones de selects
    // ============================================================
    OPTIONS: {
      DOCUMENT_TYPE: {
        CC: 'ACCOUNTING.THIRD_PARTY.FORM.OPTIONS.DOCUMENT_TYPE.CC',
        RC: 'ACCOUNTING.THIRD_PARTY.FORM.OPTIONS.DOCUMENT_TYPE.RC',
        TI: 'ACCOUNTING.THIRD_PARTY.FORM.OPTIONS.DOCUMENT_TYPE.TI',
        PP: 'ACCOUNTING.THIRD_PARTY.FORM.OPTIONS.DOCUMENT_TYPE.PP',
        NIT: 'ACCOUNTING.THIRD_PARTY.FORM.OPTIONS.DOCUMENT_TYPE.NIT',
        CE: 'ACCOUNTING.THIRD_PARTY.FORM.OPTIONS.DOCUMENT_TYPE.CE',
        PEP: 'ACCOUNTING.THIRD_PARTY.FORM.OPTIONS.DOCUMENT_TYPE.PEP',
        IE: 'ACCOUNTING.THIRD_PARTY.FORM.OPTIONS.DOCUMENT_TYPE.IE',
      },
      PERSON_TYPE: {
        NATURAL: 'ACCOUNTING.THIRD_PARTY.FORM.OPTIONS.PERSON_TYPE.NATURAL',
        JURIDICA: 'ACCOUNTING.THIRD_PARTY.FORM.OPTIONS.PERSON_TYPE.JURIDICA',
      },
      LINK_TYPE: {
        PROVEEDOR: 'ACCOUNTING.THIRD_PARTY.FORM.OPTIONS.LINK_TYPE.PROVEEDOR',
        CLIENTE: 'ACCOUNTING.THIRD_PARTY.FORM.OPTIONS.LINK_TYPE.CLIENTE',
        EMPLEADO: 'ACCOUNTING.THIRD_PARTY.FORM.OPTIONS.LINK_TYPE.EMPLEADO',
        ENTIDAD_PUBLICA: 'ACCOUNTING.THIRD_PARTY.FORM.OPTIONS.LINK_TYPE.ENTIDAD_PUBLICA',
        ENTIDAD_BANCARIA: 'ACCOUNTING.THIRD_PARTY.FORM.OPTIONS.LINK_TYPE.ENTIDAD_BANCARIA',
      },
      ACCOUNT_TYPE: {
        CORRIENTE: 'ACCOUNTING.THIRD_PARTY.FORM.OPTIONS.ACCOUNT_TYPE.CORRIENTE',
        AHORROS: 'ACCOUNTING.THIRD_PARTY.FORM.OPTIONS.ACCOUNT_TYPE.AHORROS',
        DEPOSITO_ELECTRONICO:
          'ACCOUNTING.THIRD_PARTY.FORM.OPTIONS.ACCOUNT_TYPE.DEPOSITO_ELECTRONICO',
        PENSIONADO: 'ACCOUNTING.THIRD_PARTY.FORM.OPTIONS.ACCOUNT_TYPE.PENSIONADO',
      },
      TAX_REGIME: {
        ORDINARIO: 'ACCOUNTING.THIRD_PARTY.FORM.OPTIONS.TAX_REGIME.ORDINARIO',
        SIMPLE: 'ACCOUNTING.THIRD_PARTY.FORM.OPTIONS.TAX_REGIME.SIMPLE',
        ESPECIAL: 'ACCOUNTING.THIRD_PARTY.FORM.OPTIONS.TAX_REGIME.ESPECIAL',
        NO_RESPONSABLE_IVA: 'ACCOUNTING.THIRD_PARTY.FORM.OPTIONS.TAX_REGIME.NO_RESPONSABLE_IVA',
      },
    },

    // ============================================================
    // 6. Mensajes (éxito, advertencia, error)
    // ============================================================
    MESSAGES: {
      SUCCESS: {
        CREATE: 'ACCOUNTING.THIRD_PARTY.MESSAGES.SUCCESS.CREATE',
        UPDATE: 'ACCOUNTING.THIRD_PARTY.MESSAGES.SUCCESS.UPDATE',
        DELETE: 'ACCOUNTING.THIRD_PARTY.MESSAGES.SUCCESS.DELETE',
      },
      WARNING: {
        REQUIRED_FIELDS: 'ACCOUNTING.THIRD_PARTY.MESSAGES.WARNING.REQUIRED_FIELDS',
        NO_VINCULOS: 'ACCOUNTING.THIRD_PARTY.MESSAGES.WARNING.NO_VINCULOS',
        DUPLICATE_VINCULO: 'ACCOUNTING.THIRD_PARTY.MESSAGES.WARNING.DUPLICATE_VINCULO',
        UNIQUE_ACTIVE_ACCOUNT: 'ACCOUNTING.THIRD_PARTY.MESSAGES.WARNING.UNIQUE_ACTIVE_ACCOUNT',
        DELETE_ONLY_INACTIVE: 'ACCOUNTING.THIRD_PARTY.MESSAGES.WARNING.DELETE_ONLY_INACTIVE',
        INACTIVE_NOT_EDITABLE: 'ACCOUNTING.THIRD_PARTY.MESSAGES.WARNING.INACTIVE_NOT_EDITABLE',
        DOCUMENT_IMMUTABLE: 'ACCOUNTING.THIRD_PARTY.MESSAGES.WARNING.DOCUMENT_IMMUTABLE',
      },
      ERROR: {
        LOAD: 'ACCOUNTING.THIRD_PARTY.MESSAGES.ERROR.LOAD',
        CREATE: 'ACCOUNTING.THIRD_PARTY.MESSAGES.ERROR.CREATE',
        UPDATE: 'ACCOUNTING.THIRD_PARTY.MESSAGES.ERROR.UPDATE',
        DELETE: 'ACCOUNTING.THIRD_PARTY.MESSAGES.ERROR.DELETE',
        LOAD_DETAIL: 'ACCOUNTING.THIRD_PARTY.MESSAGES.ERROR.LOAD_DETAIL',
      },
    },

    // ============================================================
    // 7. Validaciones
    // ============================================================
    VALIDATION: {
      FIELD: {
        DOCUMENT_TYPE: 'ACCOUNTING.THIRD_PARTY.VALIDATION.FIELD.DOCUMENT_TYPE',
        DOCUMENT_NUMBER: 'ACCOUNTING.THIRD_PARTY.VALIDATION.FIELD.DOCUMENT_NUMBER',
        PERSON_TYPE: 'ACCOUNTING.THIRD_PARTY.VALIDATION.FIELD.PERSON_TYPE',
        FIRST_NAME: 'ACCOUNTING.THIRD_PARTY.VALIDATION.FIELD.FIRST_NAME',
        FIRST_SURNAME: 'ACCOUNTING.THIRD_PARTY.VALIDATION.FIELD.FIRST_SURNAME',
        BUSINESS_NAME: 'ACCOUNTING.THIRD_PARTY.VALIDATION.FIELD.BUSINESS_NAME',
        ADDRESS: 'ACCOUNTING.THIRD_PARTY.VALIDATION.FIELD.ADDRESS',
        COUNTRY: 'ACCOUNTING.THIRD_PARTY.VALIDATION.FIELD.COUNTRY',
        CITY: 'ACCOUNTING.THIRD_PARTY.VALIDATION.FIELD.CITY',
        PHONE: 'ACCOUNTING.THIRD_PARTY.VALIDATION.FIELD.PHONE',
        MOBILE: 'ACCOUNTING.THIRD_PARTY.VALIDATION.FIELD.MOBILE',
        EMAIL: 'ACCOUNTING.THIRD_PARTY.VALIDATION.FIELD.EMAIL',
        ECONOMIC_ACTIVITY_CODE: 'ACCOUNTING.THIRD_PARTY.VALIDATION.FIELD.ECONOMIC_ACTIVITY_CODE',
        DV: 'ACCOUNTING.THIRD_PARTY.VALIDATION.FIELD.DV',
      },
      EMAIL_INVALID: 'ACCOUNTING.THIRD_PARTY.VALIDATION.EMAIL_INVALID',
      DV_INVALID: 'ACCOUNTING.THIRD_PARTY.VALIDATION.DV_INVALID',
      DUPLICATE_DOCUMENT: 'ACCOUNTING.THIRD_PARTY.VALIDATION.DUPLICATE_DOCUMENT',
      PATTERN: {
        DOCUMENT_NUMBER: 'ACCOUNTING.THIRD_PARTY.VALIDATION.PATTERN.DOCUMENT_NUMBER',
        NAME: 'ACCOUNTING.THIRD_PARTY.VALIDATION.PATTERN.NAME',
        DV: 'ACCOUNTING.THIRD_PARTY.VALIDATION.PATTERN.DV',
        PHONE: 'ACCOUNTING.THIRD_PARTY.VALIDATION.PATTERN.PHONE',
        ECONOMIC_ACTIVITY_CODE: 'ACCOUNTING.THIRD_PARTY.VALIDATION.PATTERN.ECONOMIC_ACTIVITY_CODE',
        DEFAULT: 'ACCOUNTING.THIRD_PARTY.VALIDATION.PATTERN.DEFAULT',
      },
    },

    // ============================================================
    // 8. Diálogos de confirmación
    // ============================================================
    DIALOG: {
      DELETE: {
        TITLE: 'ACCOUNTING.THIRD_PARTY.DIALOG.DELETE.TITLE',
        MESSAGE: 'ACCOUNTING.THIRD_PARTY.DIALOG.DELETE.MESSAGE',
        CONFIRM_LABEL: 'ACCOUNTING.THIRD_PARTY.DIALOG.DELETE.CONFIRM_LABEL',
        CANCEL_LABEL: 'ACCOUNTING.THIRD_PARTY.DIALOG.DELETE.CANCEL_LABEL',
      },
    },
  },
} as const;
